import { isRight } from 'fp-ts/Either';
import * as t from 'io-ts';
import { JSONCodec } from '../codecs/JSONCodec';

export const DonationPaymentLinksType = t.type({
  oneTime: t.string,
  oneTimeWithFees: t.string,
  monthly: t.string,
  monthlyWithFees: t.string,
});

export const DonationTierType = t.type({
  meals: t.number,
  paymentLinks: DonationPaymentLinksType,
});

export const DonationConfigType = t.intersection([
  t.type({ tiers: t.array(DonationTierType) }),
  t.partial({ manageLink: t.string }),
]);

export type IDonationPaymentLinks = t.TypeOf<typeof DonationPaymentLinksType>;
export type IDonationTier = t.TypeOf<typeof DonationTierType>;
export type IDonationConfig = t.TypeOf<typeof DonationConfigType>;

const DonationConfigCodec = new JSONCodec('DonationConfig', DonationConfigType);

export const decodeDonationConfig = (raw: string | null | undefined): IDonationConfig | null => {
  if (!raw) {
    return null;
  }
  const decoded = DonationConfigCodec.decode(raw);
  return isRight(decoded) ? decoded.right : null;
};
